import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { ModalController, IonButton, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonTitle, IonToolbar } from "@ionic/angular";
import { PlatformModeContentDirective } from "../../../../../directive/platform-mode-content.directive";
import { DragAndDropFilesComponent } from "../drag-and-drop-files/drag-and-drop-files.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-popup-settings-graphic-page",
    templateUrl: "./popup-settings-graphic-page.component.html",
    styleUrls: ["./popup-settings-graphic-page.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [IonButton, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonTitle, IonToolbar, PlatformModeContentDirective, DragAndDropFilesComponent, TranslatePipe]
})
export class PopupSettingsGraphicPageComponent {
    private readonly _modalCtrl = inject(ModalController);

    public isChangeBgExpanded: boolean = false;

    /**
     * Send data selected file and dismiss modal
     * @param event change event on html input
     */
    public onChangeSetBgImage(file: File): void {
        this._modalCtrl.dismiss(file);
    }

    /**
     * Exit without choosing an option
     */
    public onClickCancel(): void {
        this._modalCtrl.dismiss();
    }

    /**
     * Expand item for change bg image
     */
    public onClickOpenChangeBgMenu(): void {
        this.isChangeBgExpanded = !this.isChangeBgExpanded;
    }
}